export default __webpack_public_path__ + "static/media/towtruck.f4b209c8.png";